import { Form, Segment } from "semantic-ui-react";
import PropTypes from "prop-types";

import EmailHtmlFrame from "./EmailHtmlFrame";

/**
 * Email subject and preview component
 */
const EmailPreview = ({ subject, previewHtml }) => {
  return (
    <>
      <Form.Field>
        <label>Subject</label>
        <Segment>{subject}</Segment>
      </Form.Field>
      <Form.Field>
        <label>Preview</label>
        <Segment>
          <EmailHtmlFrame html={previewHtml} title="Email preview" />
        </Segment>
      </Form.Field>
    </>
  );
};

EmailPreview.propTypes = {
  subject: PropTypes.string,
  previewHtml: PropTypes.string,
};

export default EmailPreview;
